import { warn as i } from "../util/warn.js";
import e from "./DynamicWidgets.js";
export default Object.assign({}, e, {
  name: "AisExperimentalDynamicWidgets",
  mounted: function mounted() {
    i("Use AisDynamicWidgets instead of AisExperimentalDynamicWidgets.");
  }
});